import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { enviarConsulta } from "../../firebase/consultas";
import logo from "../../logo.png";

const VERDE = "#1a9e2a";
const FUENTE = "'Outfit', system-ui, sans-serif";

const TIPOS = [
  "Casa",
  "Departamento",
  "Terreno",
  "Local comercial",
  "Campo",
  "Otro",
];

export default function VenderPropiedad() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    nombre: "",
    telefono: "",
    tipoPropiedad: "",
    direccion: "",
    necesitaTasacion: "",
    dimensiones: "",
  });
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const [error, setError] = useState("");

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");

    if (!form.nombre.trim() || !form.telefono.trim() || !form.tipoPropiedad || !form.direccion.trim() || !form.necesitaTasacion) {
      setError("Por favor completá todos los campos obligatorios.");
      return;
    }

    setEnviando(true);
    try {
      await enviarConsulta({
        nombre: form.nombre.trim(),
        telefono: form.telefono.trim(),
        mensaje: `🏠 QUIERE VENDER SU PROPIEDAD\n\nTipo: ${form.tipoPropiedad}\nDirección: ${form.direccion}\nNecesita tasación: ${form.necesitaTasacion}\nDimensiones: ${form.dimensiones || "No especificadas"}`,
        tipoConsulta: "venta",
        tipoPropiedad: form.tipoPropiedad,
        direccionPropiedad: form.direccion,
        necesitaTasacion: form.necesitaTasacion,
        dimensiones: form.dimensiones,
      });
      setEnviado(true);
    } catch (err) {
      setError("Hubo un error al enviar. Intentá de nuevo.");
    }
    setEnviando(false);
  }

  if (enviado) {
    return (
      <div style={{ minHeight: "100vh", background: "#f9fafb", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", fontFamily: FUENTE, padding: "24px" }}>
        <div style={{ background: "#fff", borderRadius: "20px", padding: "48px 36px", textAlign: "center", maxWidth: "440px", width: "100%", boxShadow: "0 4px 24px rgba(0,0,0,0.07)", border: "1px solid #e5e7eb" }}>
          <div style={{ fontSize: "52px", marginBottom: "16px" }}>✅</div>
          <h2 style={{ fontSize: "22px", fontWeight: "800", color: "#111827", marginBottom: "10px", fontFamily: "Georgia, serif" }}>
            ¡Consulta enviada!
          </h2>
          <p style={{ color: "#6b7280", fontSize: "15px", lineHeight: 1.6, marginBottom: "28px" }}>
            Recibimos tu información. Nos vamos a comunicar con vos a la brevedad.
          </p>
          <button
            onClick={() => navigate("/")}
            style={{ background: VERDE, color: "#fff", border: "none", borderRadius: "12px", padding: "13px 32px", fontWeight: "700", fontSize: "15px", cursor: "pointer", fontFamily: FUENTE }}
          >
            Volver al inicio
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: "100vh", background: "#f9fafb", fontFamily: FUENTE, display: "flex", flexDirection: "column" }}>

      <nav style={{ background: "#fff", borderBottom: "1px solid #e5e7eb", padding: "12px 24px", display: "flex", alignItems: "center", justifyContent: "space-between", position: "sticky", top: 0, zIndex: 100 }}>
        <img src={logo} alt="Confalonieri Propiedades" onClick={() => navigate("/")} style={{ height: "44px", cursor: "pointer" }} />
        <button
          onClick={() => navigate("/")}
          style={{ background: "none", border: "1px solid #e5e7eb", borderRadius: "8px", padding: "8px 14px", color: "#6b7280", fontSize: "13px", cursor: "pointer", fontWeight: "600" }}
        >
          ← Volver
        </button>
      </nav>

      <div style={{ height: "4px", background: VERDE }} />

      <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", padding: "40px 20px 60px" }}>

        <div style={{ textAlign: "center", maxWidth: "560px", marginBottom: "36px" }}>
          <p style={{ fontSize: "12px", fontWeight: "700", letterSpacing: "2px", color: VERDE, textTransform: "uppercase", marginBottom: "10px" }}>
            Tasaciones y ventas
          </p>
          <h1 style={{ fontSize: "32px", fontWeight: "800", color: "#111827", margin: "0 0 12px 0", fontFamily: "Georgia, serif", lineHeight: 1.2 }}>
            Vendemos tu propiedad
          </h1>
          <p style={{ color: "#6b7280", fontSize: "15px", lineHeight: 1.7, margin: 0 }}>
            Completá el formulario y nos comunicamos con vos para asesorarte sin compromiso.
          </p>
        </div>

        <form
          onSubmit={handleSubmit}
          style={{ background: "#fff", borderRadius: "20px", padding: "36px", maxWidth: "560px", width: "100%", boxShadow: "0 4px 24px rgba(0,0,0,0.06)", border: "1px solid #e5e7eb", display: "flex", flexDirection: "column", gap: "20px" }}
        >

          <Campo label="Nombre completo *" htmlFor="nombre">
            <input id="nombre" name="nombre" type="text" placeholder="Ej: María González" value={form.nombre} onChange={handleChange} style={estiloInput} onFocus={focusInput} onBlur={blurInput} />
          </Campo>

          <Campo label="Teléfono / WhatsApp *" htmlFor="telefono">
            <input id="telefono" name="telefono" type="tel" placeholder="Ej: 3456 123456" value={form.telefono} onChange={handleChange} style={estiloInput} onFocus={focusInput} onBlur={blurInput} />
          </Campo>

          <Campo label="Tipo de propiedad *" htmlFor="tipoPropiedad">
            <select id="tipoPropiedad" name="tipoPropiedad" value={form.tipoPropiedad} onChange={handleChange} style={{ ...estiloInput, color: form.tipoPropiedad ? "#111827" : "#9ca3af" }} onFocus={focusInput} onBlur={blurInput}>
              <option value="" disabled>Seleccioná una opción</option>
              {TIPOS.map((t) => <option key={t} value={t}>{t}</option>)}
            </select>
          </Campo>

          <Campo label="Dirección de la propiedad *" htmlFor="direccion">
            <input id="direccion" name="direccion" type="text" placeholder="Ej: Sarmiento 1250, Chajarí" value={form.direccion} onChange={handleChange} style={estiloInput} onFocus={focusInput} onBlur={blurInput} />
          </Campo>

          <Campo label="¿Necesitás una tasación? *" htmlFor="necesitaTasacion">
            <div style={{ display: "flex", gap: "12px" }}>
              {["Sí", "No"].map((op) => (
                <label key={op} style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", gap: "8px", padding: "12px", borderRadius: "10px", border: `2px solid ${form.necesitaTasacion === op ? VERDE : "#e5e7eb"}`, background: form.necesitaTasacion === op ? "#f0fdf4" : "#fff", cursor: "pointer", fontWeight: "600", fontSize: "14px", color: form.necesitaTasacion === op ? VERDE : "#374151", transition: "all 0.15s" }}>
                  <input type="radio" name="necesitaTasacion" value={op} checked={form.necesitaTasacion === op} onChange={handleChange} style={{ accentColor: VERDE }} />
                  {op}
                </label>
              ))}
            </div>
          </Campo>

          <Campo label="Dimensiones aproximadas" htmlFor="dimensiones" opcional>
            <input id="dimensiones" name="dimensiones" type="text" placeholder="Ej: 200 m² cubiertos, terreno 400 m²" value={form.dimensiones} onChange={handleChange} style={estiloInput} onFocus={focusInput} onBlur={blurInput} />
          </Campo>

          {error && (
            <p style={{ color: "#dc2626", fontSize: "13px", fontWeight: "600", margin: 0, background: "#fef2f2", padding: "10px 14px", borderRadius: "8px", border: "1px solid #fecaca" }}>
              ⚠️ {error}
            </p>
          )}

          <button
            type="submit"
            disabled={enviando}
            style={{ background: enviando ? "#9ca3af" : VERDE, color: "#fff", border: "none", borderRadius: "12px", padding: "15px", fontWeight: "700", fontSize: "16px", cursor: enviando ? "not-allowed" : "pointer", fontFamily: FUENTE, transition: "background 0.2s", marginTop: "4px" }}
          >
            {enviando ? "Enviando..." : "Enviar consulta →"}
          </button>

          <p style={{ textAlign: "center", fontSize: "12px", color: "#9ca3af", margin: 0 }}>
            Nos comunicamos a la brevedad por WhatsApp o teléfono.
          </p>

        </form>
      </div>

      <footer style={{ borderTop: `3px solid ${VERDE}`, padding: "16px 24px", textAlign: "center", color: "#9ca3af", fontSize: "12px", background: "#fff" }}>
        © {new Date().getFullYear()} Confalonieri Propiedades · Sarmiento 2750, Chajarí · Todos los derechos reservados
      </footer>

    </div>
  );
}

function Campo({ label, htmlFor, children, opcional }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
      <label htmlFor={htmlFor} style={{ fontSize: "13px", fontWeight: "700", color: "#374151", display: "flex", gap: "6px", alignItems: "center" }}>
        {label}
        {opcional && <span style={{ fontSize: "11px", color: "#9ca3af", fontWeight: "500" }}>(opcional)</span>}
      </label>
      {children}
    </div>
  );
}

const estiloInput = {
  width: "100%",
  padding: "12px 14px",
  borderRadius: "10px",
  border: "1px solid #e5e7eb",
  fontSize: "14px",
  outline: "none",
  boxSizing: "border-box",
  background: "#f9fafb",
  color: "#111827",
  fontFamily: "'Outfit', system-ui, sans-serif",
  transition: "border-color 0.15s, background 0.15s",
};

function focusInput(e) {
  e.target.style.borderColor = "#1a9e2a";
  e.target.style.background = "#fff";
}

function blurInput(e) {
  e.target.style.borderColor = "#e5e7eb";
  e.target.style.background = "#f9fafb";
}
